<template>
    <div>
      <!-- TILES -->
      <div class="row align-items-center px-2">
        <div class="col-md-4">
          <tile :to="{ name: 'polizas' }" :title="contadorPolizas" :subtitle="(contadorPolizas == 1) ? 'Póliza' : 'Pólizas'" color="success"/>
        </div>
        <div class="col-md-4">
          <tile :to="{ name: 'siniestros' }" :title="contadorSiniestros" :subtitle="(contadorSiniestros == 1) ? 'Siniestro' : 'Siniestros'" color="danger"/>
        </div>
        <div class="col-md-4">
          <tile :to="{ name: 'proyectos' }" :title="contadorProyectos" :subtitle="(contadorProyectos == 1) ? 'Proyecto' : 'Proyectos'" color="azul"/>
        </div>
      </div>
      <!-- FIN TILES -->

      <!-- ACCESOS DIRECTOS -->
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-12">
            <h2 class="seccion text-primary-dark pb-2 border-bottom-0 mb-0">Accesos rápidos</h2>
          </div>
          <div class="col-lg-4 mb-2">
            <router-link :to="{ name: 'nuevoProyecto' }" class="btn btn-primary btn-block p-2 text-uppercase font-weight-bold">Nuevo seguro</router-link>
          </div>
          <div class="col-lg-4 mb-2">
            <router-link :to="{ name: 'telefonosAsistencia' }" class="btn btn-primary btn-block p-2 text-uppercase font-weight-bold">Teléfonos asistencia</router-link>
          </div>
          <div class="col-lg-4 mb-2">
            <router-link :to="{ name: 'nuevoSiniestro' }" class="btn btn-primary btn-block p-2 text-uppercase font-weight-bold">Dar parte de siniestro</router-link>
          </div>
          <div class="col-xs-12 col-lg-12">
            <hr/>
          </div>
        </div>
      </div>
      <!-- FIN ACCESOS DIRECTOS -->

      <!-- AVISOS SIN LEER -->
      <div class="container">
        <div class="row">
          <div class="container">
            <div class="col-xs-12 col-lg-12 px-0">
              <h2 class="seccion text-primary-dark pb-2 border-bottom-0 mb-01">Avisos sin leer</h2>
            </div>
            <div class="col-xs-12 col-lg-12 bg-light border rounded px-0">
              <avisos :todas="false"/>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN AVISOS SIN LEER -->

      <!-- BANNERS RUIZRE -->
      <div class="container mt-4" v-if="nombreCortoCorreduria == 'Ruizre'">
        <div class="row">
          <div class="col-md-10 offset-md-1  text-center">
            <a href="https://www.ruizre.es/noticias/" target="_blank">
              <img src="/clientes/logos/ruizre/promo.jpg" class="img-fluid"/>
            </a>
          </div>
          <div class="col-md-6 text-right pr-2 pt-3">
            <a href="https://www.seguropordias.com/?c=b03ac0f3a617df5aa963987ab76e8e55" target="_blank">
              <img src="/clientes/logos/ruizre/autos-dias.jpg" class="img-fluid"/>
            </a>
          </div>
          <div class="col-md-6 text-left pl-2 pt-3">
            <a href="https://www.aragonline.net/sites/search.php?id=MDQwNzQxMnw1" target="_blank">
              <img src="/clientes/logos/ruizre/viajes.jpg" class="img-fluid"/>
            </a>
          </div>
        </div>
      </div>
      <!-- FIN BANNERS RUIZRE -->
    </div>
</template>

<script>
// Componentes
import Avisos from '@/components/avisos/Avisos'
import Tile from '@/components/widgets/Tile'

// Extras
import util from '@/util'
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      estados: 'estados',
      nombreCortoCorreduria: 'nombreCortoCorreduria',
      contadorPolizas: 'contadorPolizas',
      contadorSiniestros: 'contadorSiniestros',
      contadorProyectos: 'contadorProyectos'
    })
  },
  mounted() {
    this.getContadorPolizas();
    this.getContadorSiniestros();
    this.getContadorProyectos();
  },
  methods: {
    getContadorPolizas() {
      let estados = [
        this.estados.polizaVigor
      ]
      let params = {
        'limit': 1,
        'estados': estados.join("2")
      }
      let url = this.urlBase + "polizas?" + util.objToQuery(params);
      this.$http.get(url).then(
        response => {
          this.$store.dispatch("setContadorPolizas", { contador: response.body.total });
        },

        error => {
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      )
    },

    getContadorSiniestros() {
      let params = {
        'estados': this.estados.siniestroAbierto,
        'limit': 1
      }
      let url = this.urlBase + "siniestros?" + util.objToQuery(params);
      this.$http.get(url).then(
        response => {
          this.$store.dispatch("setContadorSiniestros", { contador: response.body.total });
        },

        error => {
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      )
    },

    getContadorProyectos() {
      let params = {
        'sort': 'oportunidad.fechaApertura',
        'estados': '1',
        'inverse': true,
        'page': 1,
        'limit': 1
      }
      let url = this.urlBase + "oportunidades?" + util.objToQuery(params);
      this.$http.get(url).then(
        response => {
          this.$store.dispatch("setContadorProyectos", { contador: response.body.total });
        },

        error => {
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      )
    },

    
  },
  components: {
    Tile,
    Avisos
  }
}
</script>
